import sapiConfig from "../configs/sapi";
import { workCenterPlanningModel } from "../models/reportsModel";
import { httpMStepsClient } from "./utils/httpService";
import { logError } from "./utils/logService";

import * as Sentry from "@sentry/browser";

//BASE_URL
const BASE_URL = sapiConfig.api.domain;

// Odoo work order planning (mrp.workorder), grouped by work centre.
// Omit the dates to get every work order, which is what Odoo's list view shows
// (only its gantt view is scoped to the visible date window).
export const getWorkOrderPlanning = async (dateFrom?: string, dateTo?: string) => {
  let result: Array<workCenterPlanningModel> = [];
  const query = [
    dateFrom ? `date_from=${dateFrom}` : null,
    dateTo ? `date_to=${dateTo}` : null,
  ].filter(Boolean);
  const methodPath = `/work-orders${query.length ? `?${query.join("&")}` : ""}`;

  await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: methodPath,
  })
    .then((res) => {
      result = res.data.data ?? [];
    })
    .catch((error) => {
      logError(error);
      Sentry.captureException(error);
    });

  return result;
};
